import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_AA_AUGMENTED_SIGN_ASK_CONFIG = defineFcm('octopus_aa_augmented_sign_ask_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				name: { type: 'string' },
				constraints: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'TBD',
		context: 'comms stack',
		description:
			'Template experiment config for aa_augmented_sign_ask message type. Leave the constraints empty [], to enable the experiment for all countries.',
		template: {
			name: '<experiment_name>',
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	});
